module.exports = __webpack_public_path__ + "img/bittrex.236cc56f.png";